var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookIcon = function SvgBookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9.393 3.5v11.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.377 1.238c2.784.53 4.444 1.639 5.016 2.276.573-.637 2.232-1.746 5.016-2.276 1.411-.269 2.116-.403 2.717.112.6.514.6 1.35.6 3.022v6.007c0 1.529 0 2.293-.385 2.77s-1.234.639-2.932.962c-1.513.288-2.694.747-3.548 1.208-.841.454-1.262.681-1.468.681s-.626-.227-1.467-.68c-.855-.462-2.036-.921-3.549-1.21-1.697-.322-2.546-.484-2.932-.961-.385-.477-.385-1.241-.385-2.77V4.372c0-1.672 0-2.508.6-3.022.601-.515 1.307-.38 2.717-.112"
  })));
};
export default SvgBookIcon;